import { UserManager } from "oidc-client";
import { config } from 'config'

export class AuthService {
  private static userManager = (): UserManager => new UserManager(config.oidcSettings)

  static async getUser() {
    return this.userManager().getUser().then(user => {
      if(user?.expired === true) {
        return this.userManager().signinSilent()
      }

      return user
    })
  }
}
